import { AppBar, Toolbar } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { useMemo } from 'react';
import { PwrFormType } from 'src/containers/PwrPwReminder';
import i18n from '../resources/i18n';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		root: {
			flexGrow: 1,
		},
		rootchild: {
			flexGrow: 1,
			padding: theme.spacing(4),
		},
	})
);

/**
 * メール送信完了ダイアログ本体のState型
 */
interface IPwrSendMailEndState {
	/** 画面種別：パスワード再発行／ログインID通知およびパスワード再発行 */
	readonly type: PwrFormType;
}

/**
 * メール送信完了ダイアログ本体のEvent型
 */
interface IPwrSendMailEndEvents {
	/** 画面を閉じる */
	closeSendMailDialog: () => void;
}

/**
 * メール送信完了ダイアログ本体のProps型
 */
// tslint:disable-next-line:no-empty-interface
interface IPwrSendMailEndProps
	extends IPwrSendMailEndState,
		IPwrSendMailEndEvents {}

const PwrSendMailEndTytle: React.FC<{ type: PwrFormType }> = ({ type }) => {
	const classes = useStyles();

	// 画面種別毎の上部メッセージの決定
	const tytle = useMemo(
		() => {
			switch (type) {
				case 'PASSWORD_REISSUE':
					return [i18n.t('PwrSendMailEnd_0001') as string] as const;
				case 'LOGIN_ID_NOTIFICATION':
					return [i18n.t('PwrSendMailEnd_0002') as string] as const;
				default:
					const exhaustive: never = type;
					throw exhaustive;
			}
		},
		[type]
	);

	// 上部メッセージの表示（各行を i18n しつつ <br /> 挿入し結合）
	return (
		<AppBar className={classes.appBar}>
			<Toolbar>
				<Typography variant="h6" color="inherit">
					{tytle.map(line => i18n.t(line) as string)}
				</Typography>
			</Toolbar>
		</AppBar>
	);
};

/**
 * メール送信完了画面
 */
const PwrSendMailEnd: React.FC<IPwrSendMailEndProps> = ({
	type,
	closeSendMailDialog,
}) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<PwrSendMailEndTytle type={type} />
			<Paper>
				<div className={classes.rootchild}>
					<Typography>{i18n.t('PwrSendMailEnd_0003')}</Typography>
					<Grid
						container={true}
						alignItems="flex-start"
						justify="flex-end"
						direction="row"
					>
						<Button
							color="primary"
							variant="contained"
							onClick={closeSendMailDialog}
						>
							{i18n.t('PwrSendMailEnd_0004')}
						</Button>
					</Grid>
				</div>
			</Paper>
		</div>
	);
};

export default PwrSendMailEnd;



// WEBPACK FOOTER //
// ./src/containers/PwrSendMailEnd.tsx